// src/data/productsData.js

import PriceChangeIcon from "@mui/icons-material/PriceChange";
import cprImg from "../assets/smart-sap.png";
import vpmOne from "../assets/products/vmp-1.png";
import vpmTwo from "../assets/products/vmp-2.png";
import cpmOne from "../assets/products/cpm-1.png";
import cpmTwo from "../assets/products/cpm-2.png";
import adsOne from "../assets/products/ads-1.png";
import adsTwo from "../assets/products/ads-2.png";
import bpa from "../assets/products/bpa.png";

export const productsData = {
  "vendor-management-portal": {
    // =====================================================
    // PAGE DETAILS
    // =====================================================

    slug: "vendor-management-portal",

    title: "Vendor Management Portal",

    subtitle:
      "Digitally connect suppliers, automate approvals, and improve procurement efficiency.",

    label: "Vendor Portal Solution",

    icon: PriceChangeIcon,

    seo: {
      title: "Vendor Management Portal with SAP Integration | ZENCON",
      description:
        "ZENCON provides a SAP-integrated Vendor Management Portal to digitize supplier collaboration, automate approvals, manage documents, track vendor performance, and improve procurement efficiency.",
      keywords:
        "vendor management portal, SAP vendor portal, supplier portal, vendor collaboration, procurement automation, SAP supplier management, vendor performance tracking",
      image:
        "https://www.zencon-sa.com/images/products/vendor-management-portal.jpg",
    },

    // =====================================================
    // COMPONENT ONE
    // =====================================================

    componentOne: {
      image: vpmOne,

      title: "Enhance Collaboration and Streamline Vendor Management",

      description:
        "Efficient vendor management is key to a smooth supply chain and operational success. Our Vendor Portal with SAP Integration is designed to facilitate seamless communication, streamline processes, and enhance collaboration between your business and its suppliers. This powerful solution integrates directly with your SAP system, providing a centralized platform where vendors can interact with your company, access critical information, and manage their transactions with ease.",
    },

    // =====================================================
    // COMPONENT TWO
    // =====================================================

    componentTwo: {
      leftGrid: {
        title: "Key Features",

        points: [
          {
            title: "Real-Time Data Access",

            description:
              "Vendors can access real-time information related to purchase orders, invoices, payment status, and inventory levels directly through the portal.",
          },

          {
            title: "Self-Service Capabilities",

            description:
              "Empower vendors with self-service tools to update profiles, submit invoices, track payments, and manage order fulfillment independently.",
          },

          {
            title: "Seamless SAP Integration",

            description:
              "The vendor portal is fully integrated with your SAP system, ensuring all vendor-related data is synchronized in real time.",
          },

          {
            title: "Automated Notifications and Alerts",

            description:
              "Keep vendors informed with automated notifications and alerts about order updates, payment status, and delivery schedules.",
          },

          {
            title: "Document Management",

            description:
              "Allow vendors to upload and manage contracts, certifications, compliance documents, and records directly through the portal.",
          },

          {
            title: "Performance Analytics and Reporting",

            description:
              "Track delivery timelines, quality scores, compliance rates, and vendor performance through built-in reporting tools.",
          },

          {
            title: "Secure Access and Role-Based Permissions",

            description:
              "Protect sensitive information using secure access controls and role-based permission management.",
          },
        ],
      },

      rightGrid: {
        title: "Benefits",

        points: [
          {
            title: "Enhanced Collaboration",

            description:
              "Strengthen vendor relationships through transparent communication and efficient collaboration tools.",
          },

          {
            title: "Increased Efficiency",

            description:
              "Reduce manual processing time by enabling vendors to manage transactions through a self-service portal.",
          },

          {
            title: "Improved Data Accuracy",

            description:
              "Ensure synchronized and up-to-date vendor information with real-time SAP integration.",
          },

          {
            title: "Better Vendor Performance",

            description:
              "Monitor and analyze supplier performance to identify improvement opportunities and reward top-performing vendors.",
          },

          {
            title: "Scalability",

            description:
              "Support businesses of all sizes with a scalable vendor portal solution designed for growing supply chains.",
          },
        ],
      },
    },

    // =====================================================
    // COMPONENT THREE
    // =====================================================

    componentThree: {
      image: vpmTwo,

      title: "Optimize Your Vendor Relationships and Pricing Strategy",

      description:
        "The Vendor pricing solution is designed to streamline your vendor price management processes, allowing you to focus on building strong supplier relationships and optimizing your procurement strategy. With our vendor pricing solution, you can respond quickly to market changes, ensure pricing accuracy, and maintain control over your procurement operations.",
    },

    // =====================================================
    // CTA SECTION
    // =====================================================

    cta: {
      title: "Ready to Digitize and Optimize Vendor Management?",

      description:
        "Improve supplier collaboration, automate procurement workflows, and streamline vendor communication with our SAP-integrated Vendor Management Portal.",

      buttonText: "Contact Us",

      buttonLink: "/contact",
    },

    // =====================================================
    // SEO
    // =====================================================

    seo: {
      metaTitle: "Vendor Management Portal Solution | ZENCON",

      metaDescription:
        "Digitally connect suppliers, automate vendor workflows, and improve procurement efficiency with SAP-integrated vendor management solutions.",
    },
  },
  "customer-pricing-management": {
    // =====================================================
    // PAGE DETAILS
    // =====================================================

    slug: "customer-pricing-management",

    title: "Customer & Pricing Management",

    subtitle:
      "Improve pricing accuracy, customer visibility, and sales efficiency.",

    label: "SAP Pricing Automation",

    icon: PriceChangeIcon,

    seo: {
      title: "Customer & Pricing Management Solution in SAP | ZENCON",
      description:
        "ZENCON provides SAP customer and pricing management solutions to automate price amendments, approval workflows, bulk pricing updates, pricing records, and customer communication.",
      keywords:
        "customer pricing management, SAP pricing automation,  SAP customer pricing solution, price approval workflow, bulk price update SAP",
      image:
        "https://www.zencon-sa.com/images/products/customer-pricing-management.jpg",
    },

    // =====================================================
    // COMPONENT ONE
    // =====================================================

    componentOne: {
      image: cpmOne,

      title: "Easily Manage and Update Customer Pricing with Confidence",

      description:
        "In a dynamic business environment, pricing strategies often need to be adjusted to stay competitive and align with market conditions. However, managing these changes across multiple customers and contracts can be complex and time-consuming. Our Customer pricing solution simplifies this process, enabling you to quickly and accurately update customer pricing directly within your SAP system.",
    },

    // =====================================================
    // COMPONENT TWO
    // =====================================================

    componentTwo: {
      leftGrid: {
        title: "Key Features",

        points: [
          {
            title: "Seamless Integration with SAP",

            description:
              "Our customer pricing solution is fully integrated with your existing SAP environment, ensuring that all price solutions are reflected accurately across your sales, billing, and financial modules.",
          },

          {
            title: "Bulk Price Updates",

            description:
              "Easily apply bulk pricing changes across multiple customer accounts, products, or contracts with just a few clicks, saving time and reducing the risk of manual errors.",
          },

          {
            title: "Automated Notifications",

            description:
              "Notify your customers automatically of any pricing changes, ensuring transparency and maintaining strong relationships while keeping all stakeholders informed.",
          },

          {
            title: "Approval Workflow Integration",

            description:
              "Incorporate approval workflows into the pricing solution process, ensuring that all changes are reviewed and authorized before being implemented, which enhances control and compliance.",
          },

          {
            title: "Historical Pricing Records",

            description:
              "Maintain a complete history of all price solutions, allowing you to track changes over time and analyze pricing trends for strategic decision-making.",
          },

          {
            title: "Customizable Pricing Rules",

            description:
              "Define and implement customizable pricing rules based on customer segments, contract terms, or product categories, allowing for more flexible and targeted pricing strategies.",
          },
        ],
      },

      rightGrid: {
        title: "Benefits",

        points: [
          {
            title: "Increased Efficiency",

            description:
              "Automate and streamline the process of updating customer prices, reducing the administrative burden on your team and speeding up the implementation of pricing strategies.",
          },

          {
            title: "Accuracy and Compliance",

            description:
              "Ensure that all pricing updates are applied consistently and accurately across your SAP system, reducing the risk of errors and ensuring compliance with internal pricing policies.",
          },

          {
            title: "Enhanced Customer Satisfaction",

            description:
              "Keep your customers informed and confident in your pricing with automated notifications and clear communication, strengthening trust and satisfaction.",
          },

          {
            title: "Better Decision-Making",

            description:
              "Leverage historical pricing data and analytics to make informed decisions about future pricing strategies, helping you stay competitive in the market.",
          },

          {
            title: "Scalability",

            description:
              "Whether you’re updating prices for a small customer base or across thousands of accounts, the customer pricing solution is scalable to meet the needs of businesses of any size.",
          },
        ],
      },
    },

    // =====================================================
    // COMPONENT THREE
    // =====================================================

    componentThree: {
      image: cpmTwo,

      title: "Smarter Pricing Automation for Enterprise Businesses",

      description:
        "Empower your business with centralized pricing management, automated approvals, and intelligent workflows that improve operational efficiency while maintaining pricing accuracy across your SAP landscape.",
    },

    // =====================================================
    // CTA SECTION
    // =====================================================

    cta: {
      title: "Ready to Simplify Customer Pricing Management?",

      description:
        "Transform your pricing operations with our SAP-integrated customer pricing solution and improve accuracy, speed, and compliance.",

      buttonText: "Contact Us",

      buttonLink: "/contact",
    },

    // =====================================================
    // SEO
    // =====================================================

    seo: {
      metaTitle: "Customer Pricing Solution | ZENCON",

      metaDescription:
        "Manage customer price amendments efficiently inside SAP with automated workflows, pricing approvals, and bulk price update capabilities.",
    },
  },
  "business-process-automation": {
    slug: "business-process-automation",

    title: "Business Process Automation",

    subtitle:
      "Reduce manual work through intelligent automation and workflow digitization.",

    label: "Automation Solution",

    seo: {
      title: "Business Process Automation Solutions | ZENCON",
      description:
        "ZENCON delivers business process automation solutions to digitize workflows, automate approvals, reduce manual work, improve compliance, and increase operational efficiency.",
      keywords:
        "business process automation, workflow automation, SAP workflow automation, approval automation, process digitization, RPA solutions, intelligent automation",
      image:
        "https://www.zencon-sa.com/images/products/business-process-automation.jpg",
    },

    componentOne: {
      image: bpa,

      title: "Accelerate Operational Efficiency with Intelligent Automation",

      description:
        "Accelerate operational efficiency and reduce manual effort with our intelligent Business Process Automation solutions. We help organizations digitize, streamline, and automate complex business workflows to improve productivity, accuracy, compliance, and decision-making across departments.\n\nOur automation solutions eliminate repetitive manual tasks, reduce operational bottlenecks, minimize human errors, and enable faster execution through smart workflows, system integration, and real-time process visibility. By leveraging SAP technologies, workflow automation platforms, AI-driven tools, and cloud-based applications, we help businesses create agile, scalable, and highly efficient operational environments.",
    },

    componentTwo: {
      leftGrid: {
        title: "Our Automation Capabilities",

        points: [
          {
            title: "Workflow Digitization",
            description:
              "Convert manual and paper-based workflows into structured digital processes.",
          },
          {
            title: "Intelligent Process Automation",
            description:
              "Automate repetitive business activities using smart rules and system-driven actions.",
          },
          {
            title: "SAP Workflow Automation",
            description:
              "Digitize and automate SAP approval, request, and operational workflows.",
          },
          {
            title: "Approval & Escalation Management",
            description:
              "Enable faster approvals with automated routing, reminders, and escalation rules.",
          },
          {
            title: "Document & Form Automation",
            description:
              "Automate business forms, document generation, submission, and tracking.",
          },
          {
            title: "Integration Across Systems",
            description:
              "Connect SAP, cloud platforms, internal systems, and third-party applications.",
          },
          {
            title: "Real-Time Monitoring & Analytics",
            description:
              "Track workflow status, performance, bottlenecks, and process efficiency in real time.",
          },
          {
            title: "AI & Robotic Process Automation",
            description:
              "Use AI-driven tools and RPA to automate repetitive and rule-based tasks.",
          },
        ],
      },

      rightGrid: {
        title: "Business Benefits",

        points: [
          {
            title: "Reduced Manual Workload",
            description:
              "Minimize repetitive manual tasks and allow teams to focus on higher-value work.",
          },
          {
            title: "Faster Business Operations",
            description:
              "Speed up daily operations by automating approvals, routing, and task execution.",
          },
          {
            title: "Improved Process Accuracy",
            description:
              "Reduce human errors through structured workflows and automated validations.",
          },
          {
            title: "Reduced Operational Costs",
            description:
              "Lower process handling costs by reducing manual effort and operational delays.",
          },
          {
            title: "Better Compliance and Audit Tracking",
            description:
              "Maintain clear records, approval trails, and process history for audit readiness.",
          },
          {
            title: "Enhanced Productivity and Collaboration",
            description:
              "Improve teamwork through centralized workflows and transparent task ownership.",
          },
          {
            title: "Real-Time Workflow Visibility",
            description:
              "Monitor process progress, pending actions, and bottlenecks from a single view.",
          },
          {
            title: "Faster Approvals and Decision-Making",
            description:
              "Enable quicker business decisions with automated notifications and escalations.",
          },
          {
            title: "Improved Customer and Employee Experience",
            description:
              "Deliver smoother, faster, and more reliable internal and external service experiences.",
          },
        ],
      },
    },
    // componentThree: {
    //   image: cprImg,

    //   description:
    //     "Our automation solutions eliminate repetitive manual tasks, reduce operational bottlenecks, minimize human errors, and enable faster execution through smart workflows, system integration, and real-time process visibility.\n\nBy leveraging SAP technologies, workflow automation platforms, AI-driven tools, and cloud-based applications, we help businesses create agile, scalable, and highly efficient operational environments.",
    // },
  },
  "automated-digital-signature-tool-in-sap": {
    // =====================================================
    // PAGE DETAILS
    // =====================================================

    slug: "automated-digital-signature-tool-in-sap",

    title: "Automated Digital Signature Tool in SAP",

    subtitle: "Streamline Document Signing with Seamless SAP Integration",

    label: "Digital Signature Solution",

    icon: PriceChangeIcon,

    heroImage: "/images/products/digital-signature/hero-banner.jpg",

    seo: {
      title: "Automated Digital Signature Tool in SAP | ZENCON",
      description:
        "ZENCON provides an automated digital signature tool integrated with SAP to streamline document signing, secure approvals, maintain audit trails, and reduce paperwork.",
      keywords:
        "SAP digital signature, automated digital signature tool, electronic signature SAP, document signing automation, SAP approval workflow, digital signature solution",
      image: "https://www.zencon-sa.com/images/products/digital-signature.jpg",
    },

    // =====================================================
    // COMPONENT ONE
    // =====================================================

    componentOne: {
      image: adsOne,

      title: "Streamline Document Signing with Seamless SAP Integration",

      description:
        "In today's digital world, ensuring the authenticity, integrity, and security of documents is more important than ever. Our Automated Digital Signature Tool in SAP is designed to simplify and secure the document signing process within your SAP environment. This powerful tool enables you to sign, verify, and manage digital signatures directly in SAP, reducing paperwork, speeding up processes, and ensuring compliance with legal and industry standards.",
    },

    // =====================================================
    // COMPONENT TWO
    // =====================================================

    componentTwo: {
      leftGrid: {
        title: "Key Features",

        points: [
          {
            title: "Seamless SAP Integration",
            description:
              "Fully integrated with your existing SAP system, allowing you to sign and manage documents directly within SAP for a seamless workflow.",
          },
          {
            title: "Automated Signing Processes",
            description:
              "Automate document signing for invoices, purchase orders, contracts, and other business documents to reduce manual intervention.",
          },
          {
            title: "Compliance with Legal Standards",
            description:
              "Ensure digitally signed documents comply with local and international legal standards such as eIDAS, ESIGN, and UETA.",
          },
          {
            title: "Secure and Encrypted Signatures",
            description:
              "Protect documents with secure encrypted digital signatures that verify signer identity and preserve document integrity.",
          },
          {
            title: "Customizable Signature Workflows",
            description:
              "Design approval and signature workflows based on signers, sequence, conditions, and business requirements.",
          },
          {
            title: "Audit Trail and Document Tracking",
            description:
              "Maintain a complete audit trail for every signed document with real-time status tracking and accountability.",
          },
          {
            title: "Support for Multiple Signature Types",
            description:
              "Support basic electronic signatures and advanced certificate-based digital signatures for different business and regulatory needs.",
          },
        ],
      },

      rightGrid: {
        title: "Benefits",

        points: [
          {
            title: "Increased Efficiency",
            description:
              "Automate and streamline document signing, reducing time and effort required to obtain approvals and finalize agreements.",
          },
          {
            title: "Enhanced Security",
            description:
              "Protect sensitive documents using encrypted digital signatures and controlled access.",
          },
          {
            title: "Improved Compliance",
            description:
              "Meet legal and industry requirements with compliant digital signatures and secure document handling.",
          },
          {
            title: "Reduced Paperwork",
            description:
              "Eliminate physical signatures and paper documents, reducing administrative overhead and supporting sustainability.",
          },
          {
            title: "Real-Time Visibility",
            description:
              "Track document status, signing progress, reminders, and completion directly from the workflow.",
          },
        ],
      },
    },

    // =====================================================
    // COMPONENT THREE
    // =====================================================

    componentThree: {
      image: adsTwo,

      title: "Transform Your Document Management with Digital Signatures",

      description:
        "The Automated Digital Signature Tool in SAP is designed to bring speed, security, and efficiency to your document signing processes. By integrating seamlessly with your SAP environment, this tool ensures that all your digital signing needs are met within a single, secure platform, helping you maintain compliance, enhance productivity, and protect your business's most important documents.",
    },

    // =====================================================
    // CTA SECTION
    // =====================================================

    cta: {
      title: "Ready to Digitize Your Document Signing Process?",

      description:
        "Improve document security, reduce paperwork, and streamline approvals with SAP-integrated digital signature automation.",

      buttonText: "Contact Us",

      buttonLink: "/contact",
    },

    // =====================================================
    // SEO
    // =====================================================

    seo: {
      metaTitle: "Automated Digital Signature Tool in SAP | ZENCON",

      metaDescription:
        "Streamline document signing with SAP-integrated digital signature automation, secure workflows, audit trails, and compliance-ready approvals.",
    },
  },
};
